export default {
  EmptyState: {
    title: 'Tilføj din første restaurant',
    description: 'Du har endnu ingen restauranter. Opret en for at komme i gang med opsætningen og modtage ordrer.',
    cta: 'Ny restaurant',
  },
};
